import DOMPurify from "dompurify";

export const sanitizeHtml = (data: string) => ({
  __html: DOMPurify.sanitize(data),
});
